export default `<p>Defi Lending Pool은 동적 단계형 연간 수익률(APY) 메커니즘을 사용합니다. 자금 효율을 최대화하기 위해 계약에는 “일일 구간 상한 정산” 메커니즘이 도입되며, 현재 수익은 현재 적용 중인 규칙에 따라 계산됩니다. 시스템은 사용자가 보유한 단계에 해당하는 최고 수익을 자동으로 적용합니다.</p>

<h2>1. 수익 메커니즘 안내</h2>
<p>지갑 승인을 완료하고 플랫폼이 약정에 따라 대출 원금을 이체하면 시스템이 해당 대출 기록을 생성합니다. 플랫폼은 매일 다음 규칙에 따라 해당 기록의 수익을 계산합니다:</p>
<ul>
  <li><strong>대출 원금:</strong> 해당 대출에 이체되고 기록된 USDT 금액;</li>
  <li><strong>단계 금리:</strong> 해당 원금 구간의 일일 수익률을 적용하며 구간의 최댓값으로 정산;</li>
  <li><strong>일일 수익:</strong> 대출 원금 × 실제 일일 수익률 ÷ 100;</li>
  <li><strong>최신 설정:</strong> 관리자가 단계를 조정하면 현재 이자는 최신 적용 규칙에 따라 다시 계산.</li>
</ul>
<p>플랫폼 수익 출금은 계정의 출금 가능 잔액과 복리 누적 기준에만 영향을 주며, <strong>온체인 지갑 잔액에는 영향을 주지 않습니다</strong>. 수익은 <strong>하루에 한 번 전체 일일 수익률</strong>을 적용해 계산합니다. 관리자 설정의 여러 시점은 당일 수익 업데이트와 표시에만 사용되며 일일 수익을 중복 계산하지 않습니다. 수익은 계정에 누적되며 “자산 → 정산 주문”에서 세부 내역을 확인할 수 있습니다. 과거 수익은 미래 성과를 보장하지 않습니다.</p>

<h2>2. 수익 단계표</h2>
<p>아래 표는 <strong>Defi Lending Pool</strong>에서 현재 적용 중인 대출 원금 단계와 해당 일일 수익률을 보여 줍니다. 개별 대출 원금이 클수록 더 높은 단계 금리를 적용받을 수 있습니다. 표의 금리는 모두 <strong>일일 백분율</strong>이며 연간 APY가 아닙니다.</p>
<!-- YIELD_TIER_TABLE -->
<p><strong>안내:</strong> 각 대출은 해당 <strong>대출 원금</strong>에 따라 하나의 단계에 독립적으로 매칭됩니다. 한 사용자가 여러 대출을 보유한 경우 각각 계산한 뒤 원금, 이자 및 원리금 합계를 집계해 표시합니다.</p>

<h2>3. 단계 매칭 규칙</h2>
<ul>
  <li>온체인 승인을 완료하고 실제 이체 후 생성된 대출 기록만 이자 계산에 참여합니다;</li>
  <li>100 USDT 미만도 대출할 수 있지만 실제 일일 수익률은 0%입니다;</li>
  <li>각 단계는 하나의 USDT 원금 구간에 해당하며 각 대출은 적용 가능한 하나의 단계에 자동 매칭됩니다;</li>
  <li>단계가 금리 구간으로 설정된 경우 해당 구간의 <strong>최대 일일 수익률</strong>로 일괄 정산합니다;</li>
  <li>단계 설정은 플랫폼 운영자가 조정할 수 있으며 변경 사항은 이후 정산에만 적용되고 과거 주문에는 영향을 주지 않습니다.</li>
</ul>

<h2>4. 정산 및 표시</h2>
<h3>4.1 정산 주기</h3>
<ul>
  <li><strong>이자 계산 빈도:</strong> 승인된 각 자산은 하루에 한 번 전체 일일 수익률로 이자를 계산하며 여러 표시 시점에서 중복 계산하지 않습니다;</li>
  <li><strong>최초 정산:</strong> 당일 승인을 완료한 지갑은 다음 날부터 이자 계산과 정산을 시작합니다;</li>
  <li><strong>주문 항목:</strong> 정산 금액, 통화(USDT / USDC), 적용 금리, 정산 시간.</li>
</ul>
<h3>4.2 자산 페이지 지표</h3>
<p>“자산” 페이지에서 <strong>누적 수익</strong>(과거 정산 합계)과 <strong>오늘 수익</strong>(당일 정산된 부분)을 확인할 수 있으며 데이터는 시스템 주문 기록을 기준으로 합니다.</p>

<h2>5. Defi Lending Pool에서 수익을 시작하는 방법</h2>
<ol>
  <li>계정에 로그인하고 호환되는 Web3 지갑을 연결합니다;</li>
  <li>지갑에서 USDT <strong>Approve(승인)</strong> 트랜잭션을 확인합니다;</li>
  <li>플랫폼이 양측의 약정에 따라 원금을 이체하면 시스템이 대출 기록을 생성합니다;</li>
  <li>각 원금은 수익 단계에 자동 매칭되며 구간은 상한값으로 계산됩니다;</li>
  <li>“자산” 페이지에서 대출 중인 원금, 현재 이자 및 원리금 합계를 확인합니다.</li>
</ol>

<h2>6. 위험 안내</h2>
<p><strong>Defi Lending Pool</strong>은 비수탁 모델을 사용하며 플랫폼은 사용자의 개인 키를 보관하지 않습니다. 온체인 승인에는 스마트 계약 및 시장 위험이 있으며 단계 금리, 풀 용량 및 정산 결과가 변경될 수 있습니다. 참여하기 전에 “규칙 및 보안” 페이지를 주의 깊게 읽어 주십시오.</p>

<p>— 단계 금리 데이터는 플랫폼 백엔드 설정에서 동기화됩니다. 페이지 표시는 참고용이며 최종 정산 금액은 일일 주문 기록을 기준으로 합니다.</p>`
